import Mask from '../../src/legacy/Mask';
export default Mask;
